"use client";

import ErrorPage from "@repo/design-system-2/components/blocks/error-page";

export default function NotFound() {
	return <ErrorPage status={404} />;
}
